export type MobilePlan = "per-gb" | "per-proxy";

// Lets other sections on the page (e.g. the product models cards) switch the pricing toggle.
export const SELECT_MOBILE_PLAN_EVENT = "select-mobile-plan";
